import React, { useState, useEffect } from "react";
import uploadfileService from "../../services/uploadfile.service";
import "./downloadpage.css";
import auth from "../../services/auth.service";
const user = auth.getCurrentUser();
import ModalAddFile from "./ModalAddFile";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import { Row, Col } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function DownloadPage() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    uploadfileService.listDownloadFiles().then((response) => {
      setData(response.data.data);
    });
  }, []);
  const submitAddfile = (form) => {
    uploadfileService
      .uploadForDownload(form)
      .then((response) => {
        setData((a) => [response.data.data, ...a]);
        setShow(false);
      })
      .catch((err) => {
        toast.error(err);
      });
  };
  const handleRemoveItem = (id) => {
    confirmAlert({
      title: "",
      message: "ต้องการลบ",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            uploadfileService
              .deleteForDownload(id)
              .then((response) => {
                setData((a) => {
                  return a.filter((item) => item.id != response.data.data.id);
                });
              })
              .catch((error) => {
                toast.error("error delete", error);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-default",
    });
  };
  return (
    <>
      <ModalAddFile
        show={show}
        hidden_func={setShow}
        func_sub={submitAddfile}
      />
      {user.user.member_type === 1 ? (
        <div>
          <button className="btn btn-primary" onClick={() => setShow(true)}>
            เพิ่มไฟล์
          </button>
          <hr />
        </div>
      ) : (
        ""
      )}
      <ul>
        {data.map((item, key) => {
          return (
            <Row key={key}>
              <Col>
                {user.user.member_type === 1 ? (
                  <i
                    className="bi bi-x"
                    onClick={() => handleRemoveItem(item.id)}
                    style={{ color: "red" }}
                  ></i>
                ) : (
                  ""
                )}
                <a
                  href={
                    process.env.REACT_APP_API + "/downloads/" + item.file_path
                  }
                  download={item.file_path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn btn-info btn-sm btn-download">
                    <i className="fa fa-download"> Download</i>
                  </button>
                </a>

                {item.desc}
              </Col>
            </Row>
          );
        })}
      </ul>
    </>
  );
}

export default DownloadPage;
